import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Button } from 'edozvola-frontend-lib/dist/ui';
import { useParams } from 'react-router-dom';
import { deleteLocationPermitComplianceQuery } from 'app/edozvola/cases/location-permit-compliance/service/location-permit-compliance.queries';

export interface ILocationPermitComplianceDeleteModal {
  idLocationPermitComplianceMap: string;
  isModalOpen: boolean;
  closeModalCallback: Function;
}

const LocationPermitComplianceDeleteModal = (props: ILocationPermitComplianceDeleteModal) => {
  const { id } = useParams<{ id: string }>();

  const { mutate: deleteMutation } = deleteLocationPermitComplianceQuery(id, props.closeModalCallback);

  return (
    <Modal isOpen={props.isModalOpen} size={'lg'} toggle={() => props.closeModalCallback()} centered>
      <ModalHeader>
        <span>Brisanje akta</span>
      </ModalHeader>
      <ModalBody>
        <div>Jeste li sigurni da želite obrisati podatke?</div>
      </ModalBody>
      <ModalFooter>
        <Button size={'lg'} label="Odustani" onClick={() => props.closeModalCallback()} />
        <Button size={'lg'} label="Obriši" color={'danger'} onClick={() => deleteMutation(props.idLocationPermitComplianceMap)} />
      </ModalFooter>
    </Modal>
  );
};

export default LocationPermitComplianceDeleteModal;
